module.exports = "<div>\r\n  <mat-form-field>\r\n    <input\r\n      matInput\r\n      [placeholder]=\"placeholder\"\r\n      [readonly]=\"readonly\"\r\n      [ngModel]=\"value\"\r\n      (ngModelChange)=\"handleValueChange($event)\">\r\n  </mat-form-field>\r\n  <igo-map-browser [map]=\"map\" [view]=\"view\"></igo-map-browser>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/form/fields/map-field/map-field.component.html
// module id = 1062
// module chunks = 0